export default "__VITE_ASSET__78971518__"